import log from './log';
import Native from './native';

/**
 * Loads Native article template
 * Finds all native ads placeholders
 * Groups them as slots
 * Fetches native article from API using a single call per group SITEID-TAG
 * Renders native ad
 * If not enough native ads, get fallback articles.
 * Render fallback articles.
 *
 * @param context
 */
function init(context) {

  if (window.isEditMode === true) {
    log(`I don\'t run in editMode.`);
    return;
  }
  // trigger on front page only for now at least
  if (document.body.dataset.pageType !== 'front') {
    return;
  }

  const adManager = new Native(context);

  adManager.getNativeTemplate()
    .then(() => {
      adManager.showNativeArticles()
        .then(() => {
          log('Show native articles done.');
          if (adManager.isBackfillNeeded()) {
            adManager.showBackfillArticles()
              .finally(() => log('Show backfill articles done.'));
          }
        });
    })
    .catch(err => log('Native article error.', err));
}

export default {
  init
};
